import React from 'react';

const JURY_MEMBERS = [
  {
    id: 1,
    firstName: 'Philippe',
    lastName: 'Durand',
    photo: 'https://ui-avatars.com/api/?name=Philippe+Durand&size=128&background=2E75B6&color=fff&bold=true',
    title: 'Directeur Innovation',
    company: 'LBPAM',
    bio: 'Philippe Durand est Directeur Innovation chez LBPAM depuis 2018. Fort de 25 ans d\'expérience dans le secteur bancaire et financier, il a piloté de nombreux programmes d\'open innovation et accompagné les startups dans leur développement. Diplômé de HEC Paris et titulaire d\'un MBA de l\'INSEAD, il est membre de plusieurs comités d\'investissement et jury d\'innovation en France et en Europe.',
    expertise: ['Finance', 'Innovation', 'Stratégie'],
    linkedin: '#',
  },
  {
    id: 2,
    firstName: 'Catherine',
    lastName: 'Moreau',
    photo: 'https://ui-avatars.com/api/?name=Catherine+Moreau&size=128&background=9B59B6&color=fff&bold=true',
    title: 'Associée - Responsable Tech & Digital',
    company: 'Investance Partners',
    bio: 'Catherine Moreau est associée chez Investance Partners où elle dirige la practice Tech & Digital. Avec plus de 20 ans d\'expérience dans le conseil en transformation digitale, elle a accompagné plus de 50 institutions financières dans leur modernisation technologique. Experte reconnue en fintech et regtech, elle intervient régulièrement dans des conférences internationales sur l\'innovation financière.',
    expertise: ['Fintech', 'Transformation digitale', 'Regtech'],
    linkedin: '#',
  },
  {
    id: 3,
    firstName: 'Marc',
    lastName: 'Lefebvre',
    photo: 'https://ui-avatars.com/api/?name=Marc+Lefebvre&size=128&background=E67E22&color=fff&bold=true',
    title: 'Professeur de Finance',
    company: 'Université Paris-Dauphine',
    bio: 'Marc Lefebvre est Professeur de Finance à l\'Université Paris-Dauphine et chercheur associé au laboratoire DRM Finance. Auteur de nombreuses publications académiques sur l\'évaluation des startups et la finance entrepreneuriale, il apporte au jury une expertise méthodologique rigoureuse. Il est également membre du conseil scientifique de France FinTech et conseiller auprès de l\'AMF sur les sujets d\'innovation financière.',
    expertise: ['Finance entrepreneuriale', 'Évaluation', 'Recherche académique'],
    linkedin: '#',
  },
];

export default function JuryMembers() {
  return (
    <div style={{ padding: '32px 0' }}>
      <div className="container">
        <div style={{ marginBottom: 32 }}>
          <h1 style={{ marginBottom: 4 }}>Membres du Jury</h1>
          <p style={{ color: 'var(--text-light)', fontSize: 14 }}>
            Le jury des Trophées de l'Innovation est composé d'experts reconnus dans les domaines de la finance, de la technologie et de l'entrepreneuriat.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
          {JURY_MEMBERS.map(member => (
            <div key={member.id} className="card" style={{ display: 'flex', gap: 28, padding: 28 }}>
              {/* Photo */}
              <div style={{ flexShrink: 0 }}>
                <img
                  src={member.photo}
                  alt={`${member.firstName} ${member.lastName}`}
                  style={{
                    width: 120, height: 120, borderRadius: '50%',
                    objectFit: 'cover', border: '3px solid var(--primary)',
                    boxShadow: '0 4px 12px rgba(92, 44, 160, 0.15)'
                  }}
                />
              </div>

              {/* Info */}
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <div>
                    <h2 style={{ margin: 0, fontSize: 20 }}>{member.firstName} {member.lastName}</h2>
                    <div style={{ fontSize: 14, color: 'var(--primary)', fontWeight: 600, marginTop: 4 }}>
                      {member.title}
                    </div>
                    <div style={{ fontSize: 13, color: 'var(--text-light)', marginTop: 2 }}>
                      {member.company}
                    </div>
                  </div>
                  <a href={member.linkedin} style={{ color: '#0A66C2', fontSize: 13, textDecoration: 'none', fontWeight: 600 }}>
                    LinkedIn
                  </a>
                </div>

                <p style={{ fontSize: 14, lineHeight: 1.8, color: 'var(--text)', marginTop: 14, marginBottom: 14 }}>
                  {member.bio}
                </p>

                <div style={{ display: 'flex', gap: 8 }}>
                  {member.expertise.map(exp => (
                    <span key={exp} className="badge" style={{
                      background: 'rgba(92, 44, 160, 0.08)', color: 'var(--primary)',
                      fontSize: 12, padding: '4px 12px'
                    }}>
                      {exp}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
